import { render, staticRenderFns } from "./PaymentFormSection.vue?vue&type=template&id=c127cbbc&scoped=true"
import script from "./PaymentFormSection.vue?vue&type=script&lang=js"
export * from "./PaymentFormSection.vue?vue&type=script&lang=js"
import style0 from "./PaymentFormSection.vue?vue&type=style&index=0&id=c127cbbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c127cbbc",
  null
  
)

export default component.exports